// Sample Google reviews for FER-AL
// Window/door manufacturing company since 1967 in Florence, Italy

const reviews = [
  {
    name: "Davide",
    text: "Cercavo una soluzione per installare delle zanzariere alle finestre senza perdere l'uso dell'apparecchio a sporgere dell'avvolgibile. FER-AL ha soddisfatto in pieno le mie esigenze installandomi delle zanzariere plissé mini molto pratiche. Sono estremamente soddisfatto della qualità e del lavoro svolto. Quando ci si rivolge a professionisti non si rimane delusi.",
    rating: 5,
    date: "2025-11-27",
  },
  {
    name: "Elena Santini",
    text: "Azienda storica con esperienza decennale. Abbiamo fatto installare un cancello in ferro battuto su misura. Lavoro artigianale di grande pregio. Molto soddisfatti del risultato finale.",
    rating: 4,
    date: "2025-05-12",
  },
  {
    name: "Marco Manzini",
    text: "Professionali. Molto gentili, disponibilità ed esperienza.. Ottimi prodotti e materiali al passo con novità tecniche e nuove tecnologie.. Buoni prezzi..",
    rating: 5,
    date: "2024-08-30",
  },
  {
    name: "Simone Bianchi",
    text: "Ottima scelta. Precisi e molto professionali. In poche ore hanno montato le zanzariere in tutta la casa. Dopo vari preventivi ho scelto quello della FER-AL perché era il più conveniente. Consigliatissima.",
    rating: 5,
    date: "2022-09-22",
  },
  {
    name: "Giusi Piras",
    text: "personalmente ho trovato grande professionalità e correttezza ,il lavoro previsto di montaggio porte interne mi è stato fatto in anticipo al periodo fissato ed è stato apprezzato per la messa in posa degli operatori che si sono dimostrati professionalmente impeccabili . Consigliatissimo.",
    rating: 5,
    date: "2023-10-15",
  },
  {
    name: "Stefano Bianconi",
    text: "Veramente un'ottima scelta seri, professionale, cortesi ed anche convenienti. Complimenti",
    rating: 5,
    date: "2024-07-18",
  },
];

export default reviews;
